export default {
  name: "Accept-Language",
  in: "header",
  required: false,
  description: "Content localization, viz. [localization](#localization)",
  schema: {
    type: "string",
    example: "cs, en;q=0.7"
  }
};
